import { render, staticRenderFns } from "./StudentByMajorAndCoursesLineAreaChart.vue?vue&type=template&id=04d145b4&"
import script from "./StudentByMajorAndCoursesLineAreaChart.vue?vue&type=script&lang=js&"
export * from "./StudentByMajorAndCoursesLineAreaChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports